export const FETCHING_ACTIVE_OR_COMING_SOON = '@app/homepage/fetchingActiveOrComingSoon';
export const FETCHED_ACTIVE_OR_COMING_SOON = '@app/homepage/fetchedActiveOrComingSoon';
export const FETCHING_CLOSED = '@app/homepage/fetchingClosed';
export const FETCHED_CLOSED = '@app/homepage/fetchedClosed';

export const fetchingActiveOrComingSoonAction = () => ({
	type: FETCHING_ACTIVE_OR_COMING_SOON
});

export const fetchedActiveOrComingSoonAction = (raffles, total, page) => ({
	type: FETCHED_ACTIVE_OR_COMING_SOON,
	raffles,
	total,
	page
});

export const fetchingClosedAction = () => ({
	type: FETCHING_CLOSED
});

export const fetchedClosedAction = (raffles, total, page) => ({
	type: FETCHED_CLOSED,
	raffles,
	total,
	page
});



// WEBPACK FOOTER //
// ./actions/HomepageActions.js